module.exports = __webpack_public_path__ + "img/dubai_24.0f85fe4d.png";